import { render, staticRenderFns } from "./SVGPhotoRotateRight.vue?vue&type=template&id=1c05a3a6&scoped=true&"
import script from "./SVGPhotoRotateRight.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoRotateRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05a3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c05a3a6')) {
      api.createRecord('1c05a3a6', component.options)
    } else {
      api.reload('1c05a3a6', component.options)
    }
    module.hot.accept("./SVGPhotoRotateRight.vue?vue&type=template&id=1c05a3a6&scoped=true&", function () {
      api.rerender('1c05a3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoRotateRight.vue"
export default component.exports